module.exports = __webpack_public_path__ + "img/horizontal_4_2_6005.c182cc9e.png";